import React from "react";

const Container = ({ children }) => {
  return <div className="p-3">{children}</div>;
};

export default Container;
